import React, { useState, useEffect } from "react";
import { connect } from "react-redux";
import axios from "axios";
import "./inasistencia.css";
import Alert from "../../../modal/alert"; // 3 niveles: inasistencia -> nomina -> components -> src

function Inasistencia(props) {
  const [personal, setPersonal] = useState([]);
  const [cedulaPersonal, setCedulaPersonal] = useState("");
  const [horas, setHoras] = useState("");
  const [minutos, setMinutos] = useState("");
  const [diasNoTrabajados, setDiasNoTrabajados] = useState("");
  const [fechaInasistencia, setFechaInasistencia] = useState("");
  const [fechasSeleccionadas, setFechasSeleccionadas] = useState([]);
  const [concepto, setConcepto] = useState("");
  const [descripcionDesc, setDescripcionDesc] = useState("");
  const [descuentosCatalogo, setDescuentosCatalogo] = useState([]);
  const [quincena, setQuincena] = useState("");
  const [mes, setMes] = useState("");
  const [anio, setAnio] = useState("");
  const [mensajealerta, setMensajealerta] = useState(false);
  const [tituloM, setTituloM] = useState("");
  const [cuerpoM, setCuerpoM] = useState("");
  const [consultarDescuentoOn, setConsultarDescuentoOn] = useState(false);
  const [listaDescuentos, setListaDescuentos] = useState([]);
  const [reporteQuincena, setReporteQuincena] = useState("");
  const [reporteMes, setReporteMes] = useState("");
  const [reporteAnio, setReporteAnio] = useState("");

  const hoy = new Date();
  const diaHoy = hoy.getDate();
  const mesHoy = String(hoy.getMonth() + 1).padStart(2, "0");
  const anioHoy = hoy.getFullYear();
  const quincenaHoy = diaHoy <= 15 ? "1" : "2";
  const esUsuarioFechasAmpliadas =
    props.usuario1 &&
    (props.usuario1.password === "Cjlp197211" ||
      props.usuario1.password === "13011970" ||
      props.usuario1.password === "AIDE1024");

  useEffect(() => {
    setQuincena(quincenaHoy);
    setMes(mesHoy);
    setAnio(String(anioHoy));
    setReporteQuincena(quincenaHoy);
    setReporteMes(mesHoy);
    setReporteAnio(String(anioHoy));
    buscarPersonal();
    buscarDescuentosCaptahuella();
  }, []);

  const buscarPersonal = () => {
    const form = new FormData();
    form.append("boton", "buscarPersonalActivos");
    const config = { headers: { "Content-Type": "text/html" } };
    const xurl =
      "https://institutobilinguelasnaciones.com/terapias/backend/inasistencia.php";
    axios.post(xurl, form, config).then((res) => {
      if (res.data.variable1) setPersonal(res.data.variable1);
    });
  };

  const buscarDescuentosCaptahuella = () => {
    const form = new FormData();
    form.append("boton", "buscarDescuentosCaptahuella");
    const config = { headers: { "Content-Type": "text/html" } };
    const xurl =
      "https://institutobilinguelasnaciones.com/terapias/backend/descuentosCaptahuella.php";
    axios.post(xurl, form, config).then((res) => {
      if (res.data.variable1 && Array.isArray(res.data.variable2)) {
        setDescuentosCatalogo(res.data.variable2);
      } else {
        setDescuentosCatalogo([]);
      }
    });
  };

  const handleClose = () => setMensajealerta(false);

  const onChangeEmpleado = (e) => setCedulaPersonal(e.target.value);
  const onChangeConcepto = (e) => {
    const value = e.target.value;
    setConcepto(value);
    // Si cambia el tipo de descuento, limpiamos el motivo de ausencia
    if (value !== "5" && descripcionDesc !== "") {
      setDescripcionDesc("");
    }
  };

  const onChangeHoras = (e) => {
    const v = e.target.value.replace(/\D/g, "").slice(0, 2);
    if (v !== "" && (parseInt(v, 10) > 8 || v.length === 2 && parseInt(v, 10) > 8)) return;
    setHoras(v);
    if (v !== "" || minutos !== "") {
      setDiasNoTrabajados("");
    }
  };

  const onChangeMinutos = (e) => {
    const v = e.target.value.replace(/\D/g, "").slice(0, 2);
    if (v !== "" && (parseInt(v, 10) > 59 || v.length === 2 && parseInt(v, 10) > 59)) return;
    setMinutos(v);
    if (v !== "" || horas !== "") {
      setDiasNoTrabajados("");
    }
  };

  const onChangeDiasNoTrabajados = (e) => {
    const raw = e.target.value.replace(/[^\d.]/g, "").slice(0, 5);
    const v = raw === "1" || raw === "" ? raw : "";
    if (v !== "") {
      setHoras("");
      setMinutos("");
    }
    setDiasNoTrabajados(v);
  };

  const getMinDate = () => {
    if (esUsuarioFechasAmpliadas) {
      if (quincenaHoy === "2") return `${anioHoy}-${mesHoy}-01`;
      if (mesHoy === "01") return `${anioHoy - 1}-12-16`;
      const mesPrev = String(parseInt(mesHoy, 10) - 1).padStart(2, "0");
      return `${anioHoy}-${mesPrev}-16`;
    }
    if (quincenaHoy === "1") return `${anioHoy}-${mesHoy}-01`;
    return `${anioHoy}-${mesHoy}-16`;
  };

  const getMaxDate = () => {
    if (quincenaHoy === "1") return `${anioHoy}-${mesHoy}-15`;
    const ultimo = new Date(anioHoy, parseInt(mesHoy, 10), 0).getDate();
    return `${anioHoy}-${mesHoy}-${String(ultimo).padStart(2, "0")}`;
  };

  const onChangeFecha = (e) => setFechaInasistencia(e.target.value);

  const fechaDentroDeLimite = (fechaStr) => {
    if (!fechaStr) return false;
    const min = getMinDate();
    const max = getMaxDate();
    return fechaStr >= min && fechaStr <= max;
  };

  const agregarFechaALista = () => {
    const f = fechaInasistencia.trim();
    if (!f) {
      setMensajealerta(true);
      setTituloM("Descuento Honorarios");
      setCuerpoM("Seleccione una fecha en el calendario antes de agregar.");
      return;
    }
    if (!fechaDentroDeLimite(f)) {
      setMensajealerta(true);
      setTituloM("Descuento Honorarios");
      setCuerpoM("La fecha debe estar dentro del rango permitido para la quincena actual.");
      return;
    }
    if (fechasSeleccionadas.includes(f)) {
      setMensajealerta(true);
      setTituloM("Descuento Honorarios");
      setCuerpoM("Esa fecha ya está en la lista.");
      return;
    }
    setFechasSeleccionadas((prev) => [...prev, f].sort());
  };

  const quitarFechaDeLista = (fechaStr) => {
    setFechasSeleccionadas((prev) => prev.filter((x) => x !== fechaStr));
  };

  const bloqueadoHorasMinutos = diasNoTrabajados !== "";
  const bloqueadoDias = horas !== "" || minutos !== "";
  const esAusencia = concepto === "5";

  const guardarDescuento = () => {
    if (!cedulaPersonal.trim()) {
      setMensajealerta(true);
      setTituloM("Descuento Honorarios");
      setCuerpoM("Seleccione un empleado.");
      return;
    }
    let fechasToSave = [...fechasSeleccionadas];
    if (fechasToSave.length === 0 && fechaInasistencia.trim()) {
      const f = fechaInasistencia.trim();
      if (fechaDentroDeLimite(f)) {
        fechasToSave = [f];
      }
    }
    if (fechasToSave.length === 0) {
      setMensajealerta(true);
      setTituloM("Descuento Honorarios");
      setCuerpoM(
        "Agregue al menos una fecha de inasistencia (botón Agregar fecha) o seleccione una fecha válida y guarde."
      );
      return;
    }
    fechasToSave = [...new Set(fechasToSave)].sort();
    if (!concepto.trim()) {
      setMensajealerta(true);
      setTituloM("Descuento Honorarios");
      setCuerpoM("Seleccione el concepto del descuento.");
      return;
    }
    if (esAusencia && !descripcionDesc.trim()) {
      setMensajealerta(true);
      setTituloM("Descuento Honorarios");
      setCuerpoM("Debe indicar el motivo de la ausencia.");
      return;
    }
    if (!bloqueadoDias && !bloqueadoHorasMinutos) {
      setMensajealerta(true);
      setTituloM("Descuento Honorarios");
      setCuerpoM("Ingrese horas y minutos a descontar o días no trabajados.");
      return;
    }

    const h = bloqueadoHorasMinutos ? "" : (horas || "0");
    const m = bloqueadoHorasMinutos ? "" : (minutos || "0");
    const diasDescontar = bloqueadoHorasMinutos ? "0:00" : `${h.padStart(2, "0")}:${m.padStart(2, "0")}`;
    const diaNoTrabajadosVal = bloqueadoHorasMinutos ? parseFloat(diasNoTrabajados) || 0 : 0;

    const formData = new FormData();
    formData.append("cedulaPersonal", cedulaPersonal.trim());
    formData.append("diasDescontar", diasDescontar);
    formData.append("diaNoTrabajados", String(diaNoTrabajadosVal));
    formData.append("fechasInasistencia", JSON.stringify(fechasToSave));
    formData.append("concepto", concepto.trim());
    formData.append(
      "descripcionDesc",
      esAusencia ? descripcionDesc.trim() : ""
    );
    formData.append("quincena", quincenaHoy);
    formData.append("mes", mesHoy);
    formData.append("anio", String(anioHoy));
    formData.append("boton", "guardarDescuentoHonorarios");

    const config = { headers: { "Content-Type": "text/html" } };
    const xurl =
      "https://institutobilinguelasnaciones.com/terapias/backend/inasistencia.php";
    axios.post(xurl, formData, config).then((res) => {
      if (res.data.variable1) {
        setMensajealerta(true);
        setTituloM("Descuento Honorarios");
        setCuerpoM(res.data.variable2 || "Descuento guardado correctamente.");
        setCedulaPersonal("");
        setHoras("");
        setMinutos("");
        setDiasNoTrabajados("");
        setFechaInasistencia("");
        setFechasSeleccionadas([]);
        setConcepto("");
        setDescripcionDesc("");
      } else {
        setMensajealerta(true);
        setTituloM("Descuento Honorarios");
        setCuerpoM(res.data.variable2 || "Error al guardar.");
      }
    });
  };

  const consultarDescuento = () => {
    if (!cedulaPersonal.trim()) return;
    const form = new FormData();
    form.append("boton", "listarDescuentos");
    form.append("cedulaPersonal", cedulaPersonal.trim());
    const config = { headers: { "Content-Type": "text/html" } };
    const xurl =
      "https://institutobilinguelasnaciones.com/terapias/backend/inasistencia.php";
    axios.post(xurl, form, config).then((res) => {
      setListaDescuentos(res.data.variable1 || []);
      setConsultarDescuentoOn(true);
    });
  };

  const cerrarConsultarDescuento = () => setConsultarDescuentoOn(false);

  const eliminarDescuento = (id) => {
    const form = new FormData();
    form.append("boton", "eliminarDescuento");
    form.append("id", String(id));
    const config = { headers: { "Content-Type": "text/html" } };
    const xurl =
      "https://institutobilinguelasnaciones.com/terapias/backend/inasistencia.php";
    axios.post(xurl, form, config).then((res) => {
      if (res.data.variable1) {
        setListaDescuentos((prev) => prev.filter((d) => d.id !== id));
        setMensajealerta(true);
        setTituloM("Descuento Honorarios");
        setCuerpoM(res.data.variable2 || "Registro eliminado correctamente.");
      } else {
        setMensajealerta(true);
        setTituloM("Descuento Honorarios");
        setCuerpoM(res.data.variable2 || "Error al eliminar.");
      }
    });
  };

  const generarReportePdf = () => {
    if (!reporteQuincena || !reporteMes || !reporteAnio) {
      setMensajealerta(true);
      setTituloM("Descuento Honorarios");
      setCuerpoM("Seleccione quincena, mes y año para generar el reporte PDF.");
      return;
    }
    const formData = new FormData();
    formData.append("quincena", reporteQuincena);
    formData.append("mes", reporteMes);
    formData.append("anio", reporteAnio);
    const xurl =
      "https://institutobilinguelasnaciones.com/terapias/fpdf/reportes/reporteInasistenciaPersonal.php";
    axios
      .post(xurl, formData, {
        headers: { "Content-Type": "text/html" },
        responseType: "arraybuffer",
      })
      .then((response) => {
        const blob = new Blob([response.data], { type: "application/pdf" });
        const fileURL = URL.createObjectURL(blob);
        window.open(fileURL);
      })
      .catch(() => {
        setMensajealerta(true);
        setTituloM("Descuento Honorarios");
        setCuerpoM("Error al generar el reporte PDF.");
      });
  };

  const meses = [
    { valor: "01", texto: "Enero" },
    { valor: "02", texto: "Febrero" },
    { valor: "03", texto: "Marzo" },
    { valor: "04", texto: "Abril" },
    { valor: "05", texto: "Mayo" },
    { valor: "06", texto: "Junio" },
    { valor: "07", texto: "Julio" },
    { valor: "08", texto: "Agosto" },
    { valor: "09", texto: "Septiembre" },
    { valor: "10", texto: "Octubre" },
    { valor: "11", texto: "Noviembre" },
    { valor: "12", texto: "Diciembre" },
  ];
  const aniosDisponibles = (() => {
    const a = anioHoy;
    const list = [];
    for (let i = a - 2; i <= a + 1; i++) list.push(String(i));
    return list;
  })();

  const textoQuincena = quincenaHoy === "1" ? "Primera" : "Segunda";

  return (
    <div className="inasistencia-flotador">
      <div className="inasistencia-modulo">
        <div className="inasistencia-header">
          <h2 className="inasistencia-titulo">DESCUENTO HONORARIOS</h2>
          <button
            type="button"
            className="inasistencia-cerrar"
            onClick={props.personalClose}
            aria-label="Cerrar"
          >
            ✕
          </button>
        </div>

        {mensajealerta && (
          <Alert
            tituloMensaje={tituloM}
            cuerpoMensaje={cuerpoM}
            open={mensajealerta}
            handleClose={handleClose}
          />
        )}

        <div className="inasistencia-modulo-scroll">
        <div className="inasistencia-cuerpo">
          <div className="inasistencia-fila">
            <label className="inasistencia-label">Empleado:</label>
            <select
              className="inasistencia-select"
              value={cedulaPersonal}
              onChange={onChangeEmpleado}
            >
              <option value="">Seleccione un Empleado</option>
              {personal.map((item) => (
                <option key={item.variable1} value={item.variable1}>
                  {item.variable3} ({item.variable2})
                </option>
              ))}
            </select>
          </div>

          <div className="inasistencia-fila">
            <label className="inasistencia-label">Horas a Descontar:</label>
            <div className="inasistencia-horas-minutos">
              <div className="inasistencia-input-grupo">
                <input
                  type="text"
                  className="inasistencia-input"
                  placeholder="Horas (máx. 8)"
                  value={horas}
                  onChange={onChangeHoras}
                  disabled={bloqueadoHorasMinutos}
                  maxLength={2}
                />
                <span className="inasistencia-sublabel">Horas</span>
              </div>
              <span className="inasistencia-separador">:</span>
              <div className="inasistencia-input-grupo">
                <input
                  type="text"
                  className="inasistencia-input"
                  placeholder="Minutos"
                  value={minutos}
                  onChange={onChangeMinutos}
                  disabled={bloqueadoHorasMinutos}
                  maxLength={2}
                />
                <span className="inasistencia-sublabel">Minutos</span>
              </div>
            </div>
          </div>

          <div className="inasistencia-fila">
            <label className="inasistencia-label">Días No Trabajados:</label>
            <div className="inasistencia-input-grupo">
              <input
                type="text"
                className="inasistencia-input inasistencia-input-dias"
                placeholder="Días"
                value={diasNoTrabajados}
                onChange={onChangeDiasNoTrabajados}
                disabled={bloqueadoDias}
              />
              <span className="inasistencia-sublabel">Días No Trabajados</span>
            </div>
          </div>

          <div className="inasistencia-fila">
            <label className="inasistencia-label">Fechas de inasistencia:</label>
            <div className="inasistencia-fecha-fila">
              <div className="inasistencia-input-grupo">
                <input
                  type="date"
                  className="inasistencia-input inasistencia-input-fecha"
                  value={fechaInasistencia}
                  onChange={onChangeFecha}
                  min={getMinDate()}
                  max={getMaxDate()}
                />
              </div>
              <button
                type="button"
                className="inasistencia-boton inasistencia-boton-agregar-fecha"
                onClick={agregarFechaALista}
              >
                Agregar fecha
              </button>
            </div>
            {fechasSeleccionadas.length > 0 && (
              <ul className="inasistencia-fechas-lista" aria-label="Fechas seleccionadas">
                {fechasSeleccionadas.map((f) => (
                  <li key={f} className="inasistencia-fecha-chip">
                    <span>{f}</span>
                    <button
                      type="button"
                      className="inasistencia-fecha-chip-quitar"
                      onClick={() => quitarFechaDeLista(f)}
                      aria-label={`Quitar ${f}`}
                    >
                      ×
                    </button>
                  </li>
                ))}
              </ul>
            )}
            <p className="inasistencia-fecha-ayuda">
              Puede agregar varias fechas con los mismos datos. Si solo registra un día, puede guardar sin agregar a la lista si la fecha del calendario es válida.
            </p>
          </div>

          <div className="inasistencia-fila">
            <label className="inasistencia-label">Concepto:</label>
            <select
              className="inasistencia-input inasistencia-input-concepto"
              value={concepto}
              onChange={onChangeConcepto}
            >
              <option value="">Seleccione el tipo de descuento</option>
              {descuentosCatalogo.map((item) => (
                <option key={item.variable1} value={String(item.variable1)}>
                  {item.variable2}
                </option>
              ))}
            </select>
          </div>

          {esAusencia && (
            <div className="inasistencia-fila">
              <label className="inasistencia-label">
                Motivo de la ausencia:
              </label>
              <input
                type="text"
                className="inasistencia-input inasistencia-input-motivo"
                placeholder="Indique el motivo de la ausencia"
                value={descripcionDesc}
                onChange={(e) => setDescripcionDesc(e.target.value)}
                maxLength={255}
              />
            </div>
          )}
        </div>

        <div className="inasistencia-franja">
          <span className="inasistencia-franja-titulo">Información de Nómina:</span>
          <span className="inasistencia-franja-datos">
            Quincena: {textoQuincena} | Mes: {mesHoy} | Año: {anioHoy}
          </span>
        </div>

        <div className="inasistencia-fila inasistencia-reporte-fila">
          <label className="inasistencia-label">Reporte PDF (quincena, mes y año):</label>
          <div className="inasistencia-reporte-selects">
            <select
              className="inasistencia-input"
              value={reporteQuincena}
              onChange={(e) => setReporteQuincena(e.target.value)}
              style={{ width: "130px" }}
            >
              <option value="">Quincena</option>
              <option value="1">Primera</option>
              <option value="2">Segunda</option>
            </select>
            <select
              className="inasistencia-input"
              value={reporteMes}
              onChange={(e) => setReporteMes(e.target.value)}
              style={{ width: "140px" }}
            >
              <option value="">Seleccione mes</option>
              {meses.map((m) => (
                <option key={m.valor} value={m.valor}>
                  {m.texto}
                </option>
              ))}
            </select>
            <select
              className="inasistencia-input"
              value={reporteAnio}
              onChange={(e) => setReporteAnio(e.target.value)}
              style={{ width: "100px" }}
            >
              <option value="">Seleccione año</option>
              {aniosDisponibles.map((a) => (
                <option key={a} value={a}>
                  {a}
                </option>
              ))}
            </select>
          </div>
        </div>
        </div>

        <div className="inasistencia-botones">
          <button type="button" className="inasistencia-boton inasistencia-boton-guardar" onClick={guardarDescuento}>
            Guardar Descuento
          </button>
          {cedulaPersonal && (
            <button type="button" className="inasistencia-boton" onClick={consultarDescuento}>
              Consultar descuento
            </button>
          )}
          <button type="button" className="inasistencia-boton" onClick={generarReportePdf}>
            Generar reporte PDF
          </button>
          <button type="button" className="inasistencia-boton" onClick={props.personalClose}>
            Salir
          </button>
        </div>

        {consultarDescuentoOn && (
          <div className="inasistencia-consultar-flotador">
            <div className="inasistencia-consultar-modulo">
              <div className="inasistencia-consultar-header">
                <span className="inasistencia-consultar-titulo">Consultar descuento</span>
                <button
                  type="button"
                  className="inasistencia-consultar-cerrar"
                  onClick={cerrarConsultarDescuento}
                  aria-label="Cerrar"
                >
                  ✕
                </button>
              </div>
              <div className="inasistencia-consultar-cuerpo">
                {listaDescuentos.length === 0 ? (
                  <p className="inasistencia-consultar-vacio">No hay registros de descuento para este empleado.</p>
                ) : (
                  <table className="inasistencia-consultar-tabla">
                    <thead>
                      <tr>
                        <th>Fecha inasistencia</th>
                        <th>Horas a descontar</th>
                        <th>Días no trabajados</th>
                        <th>Concepto</th>
                        <th>Eliminar</th>
                      </tr>
                    </thead>
                    <tbody>
                      {listaDescuentos.map((item) => (
                        <tr key={item.id}>
                          <td>{item.fechaInasistencia}</td>
                          <td>{item.diasDescontar}</td>
                          <td>{item.diaNoTrabajados}</td>
                          <td>{item.conceptoDescripcion != null ? item.conceptoDescripcion : item.concepto}</td>
                          <td>
                            <span
                              className="cerrarme1"
                              onClick={() => eliminarDescuento(item.id)}
                              role="button"
                              tabIndex={0}
                              onKeyDown={(e) => e.key === "Enter" && eliminarDescuento(item.id)}
                              aria-label="Eliminar"
                            />
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                )}
              </div>
            </div>
          </div>
        )}
      </div>
    </div>
  );
}

const mapStateToProps = (state) => ({
  usuario1: state.usuario1,
  token: state.token,
});

export default connect(mapStateToProps)(Inasistencia);
